import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, Image, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const UserMark = (props) => {
    const {t} = useTranslation()
    return(
    <>
        {props.plan === "basic" ? <span style={{cursor:"pointer"}} title="ベーシックに加入中のユーザーです。" onClick={() => props.dialog(t("common.info"),"ベーシックプランに加入中のユーザーです。")}> <span style={{backgroundColor:"#555555",borderRadius:"5px",fontSize:"12px",color:"#EEEEEE",padding:"2px"}}>BAS</span></span> : ""}
        {props.plan === "certification" ? <span style={{cursor:"pointer"}} title="スタンダードに加入中のユーザーです。" onClick={() => props.dialog(t("common.info"),"スタンダードプランに加入中のユーザーです。")}> <span style={{backgroundColor:"lightblue",borderRadius:"5px",fontSize:"12px",color:"#333333",padding:"2px"}}>STD</span></span> : ""}
        {props.plan === "unlimited" ? <span style={{cursor:"pointer"}}title="プレミアムに加入中のユーザーです。"  onClick={() => props.dialog(t("common.info"),"プレミアムプランに加入中のユーザーです。")}> <span style={{backgroundColor:"orange",borderRadius:"5px",fontSize:"12px",color:"#EEEEEE",padding:"2px"}}><Icon.Stars />PRE</span></span> : ""}
        {props.plan === "plus" ? <span style={{cursor:"pointer"}}title="プレミアムプラスに加入中のユーザーです。"  onClick={() => props.dialog(t("common.info"),"プレミアムプラスに加入中のユーザーです。")}> <span style={{background: "-moz-radial-gradient(#F13F79, #FFC778)",background: "-webkit-radial-gradient(#F13F79, #FFC778)", background: "radial-gradient(#F13F79, #FFC778)",borderRadius:"5px",fontSize:"12px",color:"#EEEEEE",padding:"2px"}}><Icon.Stars />PLUS</span></span> : ""}
        {props.beginner === 1 ? <> <span style={{cursor:"pointer"}} title='登録して間もない利用者です。' onClick={() => props.dialog(t("common.info"),"登録して間もない利用者です。")}>🔰</span></> : ""}
        {props.sms_auth && (props.plan === "" || props.plan === "basic") ? (
        <Icon.CheckCircleFill
        onClick={() => props.dialog(t("common.info"),"SMS認証済み。")}
        style={{display:props.sms_auth ? "inline" : "none",color:"#1D9BF0",cursor:"pointer",marginLeft:"10px"}}
        title="SMS認証済み。"
        /> 
        ):""}
        {props.sms_auth && (props.plan === "certification" || props.plan === "unlimited") ? (
        <Icon.CheckCircleFill
        onClick={() => props.dialog(t("common.info"),"SMS認証、サブスクリプションによる認証済み。")}
        style={{display:props.sms_auth ? "inline" : "none",color:"#E2B719",cursor:"pointer",marginLeft:"10px"}}
        title="SMS認証、サブスクリプションによる認証済み。"
        />
        ):""}
        {props.identity_confirmed === 2 ? (
            <Icon.ShieldFillCheck
            onClick={() => props.dialog(t("common.info"),"このアカウントはアワートAIの公認クリエイターです。(身分証明書提出による本人確認済)")}
            style={{display:"inline",color:"#E2B719",cursor:"pointer",marginLeft:"10px"}}
            title="このアカウントはアワートAIの公認クリエイターです。(身分証明書提出による本人確認済)" />
        ) : (
            <Icon.ShieldFillCheck
            onClick={() => props.dialog(t("common.info"),"このアカウントはアワートAIの公認クリエイターです。")}
            style={{display:props.role && props.role.find(d => d.role_div === "official_user") || props.creator ? "inline" : "none",color:"green",cursor:"pointer",marginLeft:"10px"}}
            title="このアカウントはアワートAIの公認クリエイターです。" />
        )}
        <Image src='/img/logo_s.png'
        width={24}
        onClick={() => props.dialog(t("common.info"),"このアカウントはアワートAIに関するアカウントです。")}
        style={{display:props.role && props.role.find(d => d.role_div === "admin") ? "inline" : "none",color:"green",cursor:"pointer",marginLeft:"10px"}}
        title="このアカウントはアワートAIに関するアカウントです。" />
        <Image src='/img/logo_s.png'
        width={24}
        onClick={() => props.dialog(t("common.info"),"このアカウントはアワートAIのモデレーターです。")}
        style={{display:props.moderator_badge_display_flag === 1 && props.role && props.role.find(d => d.role_div === "moderator") ? "inline" : "none",color:"green",cursor:"pointer",marginLeft:"10px",borderRadius:"15px",border:"3px solid orange"}}
        title="このアカウントはアワートAIのモデレーターです。" />
    </>
    )
}

export default UserMark;
